import React from 'react';
export const StarHalf = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "2 0 16 17",
    className: className
  }, /*#__PURE__*/React.createElement("title", null, "Half star"), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA400",
    d: "M12.934 9.8l2.941-2.995-4.059-.625L10 2.329 8.183 6.18l-4.058.625L7.067 9.8l-.702 4.244L10 12.038l3.625 2.006-.691-4.244zM18 6.2c0 .148-.083.31-.25.484l-3.49 3.569.827 5.041c.006.047.011.114.011.202 0 .336-.132.504-.395.504a.76.76 0 0 1-.385-.121L10 13.5l-4.317 2.379a.796.796 0 0 1-.385.121.346.346 0 0 1-.303-.146.618.618 0 0 1-.101-.357c0-.041.007-.107.02-.202l.827-5.041-3.5-3.569C2.08 6.503 2 6.341 2 6.2c0-.249.18-.403.539-.463L7.365 5 9.529.413C9.651.138 9.808 0 10 0s.349.138.471.414L12.635 5l4.827.736c.358.061.538.216.538.464z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA400",
    d: "M10 12.228V2.121L8.093 6.13l-4.26.65 3.088 3.117-.736 4.418z"
  }));
};
export default StarHalf;